import { formatPersonName } from '@/utils';
import type {
  LC_FilteredEmployeeItem,
  LC_GetEmployeesFilteredOut,
  FilteredEmployee,
  FilteredEmployeesPage,
} from '../types/employeeFiltered.types';


// El backend arma displayName como "ApellidoPaterno ApellidoMaterno Nombres (RUT)",
// por lo que sólo se normaliza el caso; el sufijo con el RUT queda intacto.
export function mapFilteredEmployee(item: LC_FilteredEmployeeItem): FilteredEmployee {
  return {
    employeeId: item.employeeId,
    displayName: formatPersonName(item.displayName ?? ''),
  };
}

export function mapFilteredEmployeesPage(data: LC_GetEmployeesFilteredOut): FilteredEmployeesPage {
  const items = data.data ?? [];
  const { pagination } = data;

  return {
    items: items.map(mapFilteredEmployee),
    pagination: {
      currentPage: pagination.currentPage,
      pageSize: pagination.pageSize,
      totalRecords: pagination.totalRecords,
      totalPages: pagination.totalPages,
      hasPreviousPage: pagination.hasPreviousPage,
      hasNextPage: pagination.hasNextPage,
    },
    validatedSelection: data.validatedSelection ?? [],
  };
}
